import styled from 'styled-components';
import ActionBar from '../../buttons/ActionBar';

import T3 from '../../titles/T3';

export const StyledErrorMessage = styled.div`
  &:not(:last-child) {
    padding-bottom: 24px; 
  }
`;

export const StyledErrorTitle = styled(T3)`
  margin-bottom: 16px;
`;

export const StyledErrorText = styled.div`
padding-bottom: 20px;`;

export const StyledHint = styled.div`
  margin-bottom: 12px;
  font-size: 14px;
`;

export const StyledActionBar = styled(ActionBar)`
  margin-top: 5px;
  justify-content: center;
`;
